export const CAMPAIGN_LIST = 'ROLE_Campaign_collection_get';
export const CAMPAIGN_CREATE = 'ROLE_Campaign_collection_post';
export const CAMPAIGN_SHOW = 'ROLE_Campaign_item_get';
export const CAMPAIGN_EDIT = 'ROLE_Campaign_item_put';
export const CAMPAIGN_DELETE = '';